import React from "react";
import { Attribute, Column } from "../constants";

interface DataStudioDropdownProps {
  position?: "fixed" | "relative" | "static";
  options: Column[];
  onSelect: (item: Column) => void;
  dropdownPositionTop?: string;
  dropdownPositionLeft?: string;
}

const DataStudioDropdown: React.FC<DataStudioDropdownProps> = ({
  options,
  onSelect,
  position = "static",
  dropdownPositionTop,
  dropdownPositionLeft,
}) => {
  return (
    <div
      className="DataStudio"
      style={{
        position: position,
        top: dropdownPositionTop ?? "",
        left: dropdownPositionLeft ?? "",
      }}
    >
      {options?.map((column, index) => (
        <div className="options" key={index} onClick={() => onSelect(column)}>
          {(column as Attribute)?.displayName || column?.name}
        </div>
      ))}
    </div>
  );
};

export default DataStudioDropdown;
